import { WalletMembershipIcon } from './WalletMembershipIcon';

/**
 * author: Google
 * id BBE325B3-416A-4160-8E95-162B076B8839
 * name wallet-membership
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/wallet-membership.svg
 * tags
 */
export const CardMembershipIcon = WalletMembershipIcon;
export default CardMembershipIcon